import request from '@/utils/http';
// 盖章人信息-管理端-查询列表
export const getDataList = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierStamperInfos`,
        method: 'post',
        data: params
    });
};
// 盖章人信息-管理端-启用
export const startStamperInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/enableSupplierStamperInfo`,
        method: 'put',
        data: params
    });
};
// 盖章人信息-管理端-停用
export const stopStamperInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/prohibitSupplierStamperInfo`,
        method: 'put',
        data: params
    });
};
// 盖章人信息-管理端-同步
export const synStamperInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/synStamperInfo`,
        method: 'post',
        data: params
    });
};
// 盖章人信息-管理端-前往授权
export const getAuthorizationUrl = (params) => {
    return request({
        url: `/api-srm-web/supplier/getAuthorizationUrl`,
        method: 'get'
    });
};
// 生成盖章人
export const generateSealer = (params) => {
    return request({
        url: `/api-srm-web/supplier/individualInsertStamper`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};